export type Receipt = Record<string, unknown>;

function asString(value: unknown): string {
  return typeof value === "string" ? value : "";
}

export function explainReceipt(receipt: Receipt): readonly string[] {
  const reason = asString(receipt.reason);
  const lines: string[] = [];

  if (reason === "DOMAIN_NOT_ALLOWLISTED") {
    lines.push("Policy evaluation failed: domain not on allowlist.");
    lines.push(
      "This is independent of δ: override does not silently bypass allowlist.",
    );
  } else if (reason === "UNTRUSTED_PROVENANCE_NO_BRIDGE") {
    lines.push(
      "Provenance gate failed: untrusted text cannot directly invoke execution.",
    );
    lines.push(
      "Structural cause: missing bridge from epistemic input to execution authority.",
    );
  } else if (reason === "MATRIX_FORBIDS_SEQUENCE") {
    lines.push(
      "Composition gate failed: matrix forbids the bridge sequence needed for execution.",
    );
  } else if (reason === "MISSING_WITNESSES") {
    lines.push("Witness gate failed: required witnesses missing.");
  } else if (reason === "BUDGET_FAILURE") {
    lines.push(
      "Containment gate failed: insufficient budget or invalid ledger transition.",
    );
  } else if (asString(receipt.kind) === "EXECUTE") {
    lines.push("Execution succeeded under the active regime constraints.");
  } else {
    lines.push("No specialized explanation for this receipt.");
  }

  const forbiddenShapeId = asString(receipt.forbidden_shape_id);
  const missingBridgeId = asString(receipt.missing_bridge_id);
  if (forbiddenShapeId) lines.push(`Forbidden shape: ${forbiddenShapeId}`);
  if (missingBridgeId) lines.push(`Missing bridge: ${missingBridgeId}`);
  return lines;
}
